import { styled } from 'styled-components';
import { flexMixin } from '@styles/mixins';

export const ChartContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 500px;
    overflow: hidden;
`;

export const LegendContainer = styled.div`
    flex-shrink: 0;
    margin-bottom: 20px;
    ${flexMixin('row', 'center', 'center')};
`;

export const ChartContainer = styled.div`
    position: relative;
    flex: 1;
    min-height: 200px;
`;
